import { Component } from 'vue-property-decorator';
import { DateFilter, PolicyStatus } from 'admiral-core';
import { BaseMixin } from '@/mixins/BaseMixin';

@Component
export class FilterMixin extends BaseMixin {
  openedFilter = false;

  dateOptions = [
    DateFilter.TODAY,
    DateFilter.THIS_WEEK,
    DateFilter.THIS_MONTH,
    DateFilter.THIS_YEAR,
    DateFilter.ALL,
    DateFilter.CUSTOM,
  ];

  statusFilterOption = [
    PolicyStatus.PLANNED,
    PolicyStatus.OPEN,
    PolicyStatus.SUBMITTED,
    PolicyStatus.POLICED,
    PolicyStatus.DECLINED,
  ];

  dateFilterNames(dateFilter: DateFilter) {
    const dateOptions = {
      [DateFilter.TODAY]: 'Heute',
      [DateFilter.THIS_WEEK]: 'Diese Woche',
      [DateFilter.THIS_MONTH]: 'Dieser Monat',
      [DateFilter.THIS_YEAR]: 'Dieses Jahr',
      [DateFilter.ALL]: 'Alle',
      [DateFilter.CUSTOM]: 'Benutzerdefiniert',
    };
    return dateOptions[dateFilter];
  }

  statusFilterNames(status: PolicyStatus) {
    const statusOptions = {
      [PolicyStatus.OPEN]: 'Offen',
      [PolicyStatus.SUBMITTED]: 'Eingereicht',
      [PolicyStatus.POLICED]: 'Policiert',
      [PolicyStatus.DECLINED]: 'Abgesagt',
      [PolicyStatus.PLANNED]: 'Geplant',
      [PolicyStatus.CANCELED]: 'Storniert',
    };

    return statusOptions[status];
  }

  onClick(event: MouseEvent) {
    if (
      event.target &&
      (this.$refs.button as HTMLButtonElement | undefined)?.contains(event.target as HTMLElement)
    ) {
      return;
    }
    if (!this.openedFilter || !event.target || !this.$refs.popover) return;
    if (!(this.$refs.popover as HTMLElement).contains(event.target as HTMLElement)) {
      this.close();
    }
  }

  open() {
    if (this.openedFilter) {
      this.close();
      return;
    }
    this.openedFilter = true;
    document.body.addEventListener('click', this.onClick);
  }
  close() {
    this.openedFilter = false;
    document.body.removeEventListener('click', this.onClick);
  }
}
